// src/pages/Datenschutz.tsx
import { Layout } from '@/components/Layout';

export default function Datenschutz() {
  return (
    <Layout>
      <div className="container mx-auto px-4 py-16 max-w-3xl">
        <h1 className="text-3xl font-bold mb-2">Datenschutzerklärung</h1>
        <p className="text-muted-foreground text-sm mb-10">Stand: April 2026</p>

        <div className="space-y-10 text-sm leading-relaxed text-foreground">

          <section>
            <h2 className="font-bold text-lg mb-3">1. Verantwortlicher</h2>
            <p>
              Verantwortlicher im Sinne der Datenschutz-Grundverordnung (DSGVO) ist:<br /><br />
              Jonas Huber<br />
              Ferdinand-Wallbrecht-Straße 55<br />
              30163 Hannover<br />
              E-Mail: <a href="mailto:kontakt@salesforge.de" className="text-primary underline">kontakt@salesforge.de</a>
            </p>
          </section>

          <section>
            <h2 className="font-bold text-lg mb-3">2. Allgemeines zur Datenverarbeitung</h2>
            <p>
              Wir verarbeiten personenbezogene Daten nur, soweit dies für die Bereitstellung
              unserer Plattform und der damit verbundenen Leistungen erforderlich ist. Die
              Verarbeitung erfolgt auf Basis der im Folgenden genannten Rechtsgrundlagen der DSGVO.
              Das Angebot richtet sich ausschließlich an Unternehmer im Sinne des § 14 BGB.
            </p>
          </section>

          <section>
            <h2 className="font-bold text-lg mb-3">3. Erhobene Daten und Verarbeitungszwecke</h2>

            <h3 className="font-semibold mb-1 mt-4">3.1 Audit-Eingaben</h3>
            <p>
              Im Rahmen des kostenlosen Sales-Audits geben Nutzer Angaben zu ihrem Unternehmen
              und Vertriebsprozess ein (z. B. Teamgröße, Umsatz, Prozessreifegrad). Diese Daten
              werden verarbeitet, um eine individuelle Analyse zu erstellen und Handlungsempfehlungen
              zu generieren.
            </p>
            <ul className="list-disc list-inside mt-2 space-y-1 text-muted-foreground">
              <li>Zweck: Erstellung der Audit-Auswertung und Handlungsempfehlungen</li>
              <li>Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung)</li>
              <li>Speicherdauer: Bis zur Löschung durch den Nutzer oder nach 24 Monaten Inaktivität</li>
            </ul>

            <h3 className="font-semibold mb-1 mt-4">3.2 Kontaktformular</h3>
            <p>
              Bei Nutzung des Kontaktformulars werden Name, E-Mail-Adresse und die Nachricht
              übermittelt. Diese Daten werden ausschließlich zur Bearbeitung der Anfrage verwendet.
            </p>
            <ul className="list-disc list-inside mt-2 space-y-1 text-muted-foreground">
              <li>Zweck: Beantwortung von Anfragen</li>
              <li>Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse)</li>
              <li>Speicherdauer: 6 Monate nach abschließender Bearbeitung</li>
            </ul>

            <h3 className="font-semibold mb-1 mt-4">3.3 Zahlungsdaten (Stripe)</h3>
            <p>
              Für die Freischaltung kostenpflichtiger Inhalte (einmalig 149 €) wird die Zahlung
              über den Zahlungsdienstleister Stripe, Inc. abgewickelt. Zahlungsrelevante Daten
              (Kreditkartendaten, IBAN etc.) werden ausschließlich von Stripe verarbeitet und
              erreichen unsere Server nicht. Wir erhalten lediglich eine Bestätigung des
              Zahlungsstatus sowie eine anonymisierte Transaktions-ID.
            </p>
            <ul className="list-disc list-inside mt-2 space-y-1 text-muted-foreground">
              <li>Zweck: Zahlungsabwicklung und Freischaltung von Inhalten</li>
              <li>Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung)</li>
              <li>Datenschutzerklärung Stripe:{' '}
                <a href="https://stripe.com/de/privacy" target="_blank" rel="noopener noreferrer" className="text-primary underline">
                  stripe.com/de/privacy
                </a>
              </li>
            </ul>
          </section>

          <section>
            <h2 className="font-bold text-lg mb-3">4. Eingesetzte Dienste und Auftragsverarbeiter</h2>

            <h3 className="font-semibold mb-1 mt-4">4.1 Supabase</h3>
            <p>
              Zur Speicherung von Nutzerdaten und zur Bereitstellung der Plattform nutzen wir
              Supabase (Supabase Inc., San Francisco, USA). Supabase fungiert als
              Auftragsverarbeiter gemäß Art. 28 DSGVO. Die Datenverarbeitung erfolgt auf Basis
              eines Auftragsverarbeitungsvertrags. Supabase nutzt Infrastrukturen in der EU
              (Frankfurt, AWS eu-central-1). Weitere Informationen:{' '}
              <a href="https://supabase.com/privacy" target="_blank" rel="noopener noreferrer" className="text-primary underline">
                supabase.com/privacy
              </a>
            </p>

            <h3 className="font-semibold mb-1 mt-4">4.2 KI-gestützte Inhalte</h3>
            <p>
              Teile der Audit-Auswertung und Handlungsempfehlungen werden mithilfe automatisierter
              Systeme und KI-gestützter Verarbeitung erstellt. Die Ergebnisse basieren auf den
              eingegebenen Daten und stellen keine individuelle Unternehmensberatung dar.
            </p>
          </section>

          <section>
            <h2 className="font-bold text-lg mb-3">5. Datensicherheit</h2>
            <p>
              Wir setzen technische und organisatorische Sicherheitsmaßnahmen ein, um Ihre Daten
              vor unbefugtem Zugriff, Verlust oder Manipulation zu schützen. Die Übertragung
              erfolgt ausschließlich über verschlüsselte HTTPS-Verbindungen. Zugriffsberechtigungen
              sind auf das notwendige Minimum beschränkt.
            </p>
          </section>

          <section>
            <h2 className="font-bold text-lg mb-3">6. Ihre Rechte als betroffene Person</h2>
            <p>Sie haben jederzeit das Recht auf:</p>
            <ul className="list-disc list-inside mt-2 space-y-1">
              <li><strong>Auskunft</strong> über die zu Ihrer Person gespeicherten Daten (Art. 15 DSGVO)</li>
              <li><strong>Berichtigung</strong> unrichtiger Daten (Art. 16 DSGVO)</li>
              <li><strong>Löschung</strong> Ihrer Daten, soweit keine gesetzlichen Aufbewahrungspflichten entgegenstehen (Art. 17 DSGVO)</li>
              <li><strong>Einschränkung</strong> der Verarbeitung (Art. 18 DSGVO)</li>
              <li><strong>Datenübertragbarkeit</strong> (Art. 20 DSGVO)</li>
              <li><strong>Widerspruch</strong> gegen die Verarbeitung (Art. 21 DSGVO)</li>
            </ul>
            <p className="mt-3">
              Zur Ausübung Ihrer Rechte wenden Sie sich bitte an:{' '}
              <a href="mailto:[E-Mail]" className="text-primary underline">[E-Mail]</a>
            </p>
            <p className="mt-3">
              Sie haben außerdem das Recht, sich bei der zuständigen Datenschutz-Aufsichtsbehörde
              zu beschweren.
            </p>
          </section>

          <section>
            <h2 className="font-bold text-lg mb-3">7. Cookies und Tracking</h2>
            <p>
              Diese Plattform setzt ausschließlich technisch notwendige Cookies ein, die für den
              Betrieb der Anwendung erforderlich sind (z. B. Session-Management). Es werden keine
              Tracking- oder Analyse-Cookies von Drittanbietern eingesetzt.
            </p>
          </section>

          <section>
            <h2 className="font-bold text-lg mb-3">8. Änderungen dieser Datenschutzerklärung</h2>
            <p>
              Wir behalten uns vor, diese Datenschutzerklärung bei Änderungen der Rechtslage,
              der eingesetzten Dienste oder der Plattform anzupassen. Die jeweils aktuelle Version
              ist auf dieser Seite abrufbar.
            </p>
          </section>

        </div>
      </div>
    </Layout>
  );
}
